module.exports = __webpack_public_path__ + "img/pagado.44f3b615.png";